import { ROUTES } from "@nf/constants";
import React from "react";
import { useTranslation } from "next-i18next";

import Button from "components/Button";

import SearchIcon from "../../../resources/icons/search.svg";

import styles from "./SearchInput.module.scss";

export type SearchButtonProps = {
  onClick?: () => void;
};

export const SearchButton = ({ onClick }: SearchButtonProps) => {
  const { t } = useTranslation("translations");

  if (onClick) {
    return (
      <Button
        size="small"
        variant="tertiary"
        icon={<SearchIcon className={styles.searchIcon} />}
        onClick={onClick}
      />
    );
  }

  return (
    <Button
      href={ROUTES.SEARCH_SCREEN}
      size="small"
      variant="tertiary"
      aria-label={t("web_menu_search")}
      icon={<SearchIcon />}
    />
  );
};

export default SearchButton;
